import * as React from 'react';

import './CardScrollSection.scss';

interface ICardScrollSection {
    isLoading?: boolean;
    height: string;
    emptyMessage?: string | JSX.Element;
}

const CardScrollSection: React.StatelessComponent<ICardScrollSection> = (props) => {
    const sectionStyle = {
        height: props.height,
    };

    let content: JSX.Element | React.ReactNode = undefined;

    if (Array.isArray(props.children) && (props.children as Array<JSX.Element>).length === 0) {
        content = <div className="empty-message">{props.emptyMessage || 'No Results Found'}</div>;
    } else {
        content = props.children;
    }

    return (
        <div className="lh-scroll-section" style={sectionStyle}>
            {content}
        </div>
    );
};

export default CardScrollSection;



// WEBPACK FOOTER //
// ./src/components/common/CardScrollSection.tsx